<template>
  <span v-if="!field">{{ dispValue }}</span>
  <!--  TEXT FIELDS-->
  <div v-else-if="!field.type && !field.innerModel" class="text-field"><i :class="inputIcon" class="el-input__icon"/>{{ flightOrder[field.modelField] }}</div>
  <div v-else-if="!field.type && field.innerModel" class="text-field"><i :class="inputIcon" class="el-input__icon"/>{{ flightOrder.orderData[field.modelField] }}</div>
  <!-- STRING FIELDS -->
  <el-input
    v-else-if="field.type == 'string' && !listObject && !field.innerModel"
    v-model="flightOrder[field.modelField]"
    :placeholder="placeholder"
    :prefix-icon="inputIcon"
    :disabled="disabled"
    size="mini"
    @change="onChange"
    @input="$emit('input', $event)"
  />
  <el-input
    v-else-if="field.type == 'string' && !listObject && field.innerModel"
    v-model="flightOrder.orderData[field.modelField]"
    :placeholder="placeholder"
    :prefix-icon="inputIcon"
    :disabled="disabled"
    size="mini"
    @change="onChange"
    @input="$emit('input', $event)"
  />
  <!--  TEXTAREA FIELD-->
  <el-input
    v-else-if="field.type == 'textarea' && !listObject && !field.innerModel"
    v-model="flightOrder[field.modelField]"
    :placeholder="placeholder"
    :prefix-icon="inputIcon"
    :disabled="disabled"
    type="textarea"
    size="mini"
    @change="onChange"
    @input="$emit('input', $event)"
  />
  <el-input
    v-else-if="field.type == 'textarea' && !listObject && field.innerModel"
    v-model="flightOrder.orderData[field.modelField]"
    :placeholder="placeholder"
    :prefix-icon="inputIcon"
    :disabled="disabled"
    type="textarea"
    size="mini"
    @change="onChange"
    @input="$emit('input', $event)"
  />
  <!--  SELECT FIELD-->
  <el-select
    v-else-if="field.type == 'string' && listObject && !field.innerModel"
    v-model="flightOrder[field.modelField]"
    :placeholder="placeholder"
    :clearable="false"
    :disabled="disabled"
    filterable
    size="mini"
    @change="onChange"
    @input="$emit('input', $event)"
  >
    <el-option v-for="item in listObject.list" :key="item[listObject.key]" :label="item[listObject.label]" :value="item[listObject.value]"/>
  </el-select>
  <el-select
    v-else-if="field.type == 'string' && listObject && field.innerModel"
    v-model="flightOrder.orderData[field.modelField]"
    :placeholder="placeholder"
    :clearable="false"
    :disabled="disabled"
    filterable
    size="mini"
    @change="onChange"
    @input="$emit('input', $event)"
  >
    <el-option v-for="item in listObject.list" :key="item[listObject.key]" :label="item[listObject.label]" :value="item[listObject.value]"/>
  </el-select>
  <!-- DATE FIELDS -->
  <el-date-picker
    v-else-if="field.type == 'date' && !field.innerModel"
    v-model="flightOrder[field.modelField]"
    :clearable="false"
    :placeholder="placeholder"
    :picker-options="{ firstDayOfWeek: 1 }"
    :disabled="disabled"
    format="dd.MM.yyyy"
    size="mini"
    @change="onChange"
    @input="$emit('input', $event)"
  />
  <el-date-picker
    v-else-if="field.type == 'date' && field.innerModel"
    v-model="flightOrder.orderData[field.modelField]"
    :clearable="false"
    :placeholder="placeholder"
    :picker-options="{ firstDayOfWeek: 1 }"
    :disabled="disabled"
    format="dd.MM.yyyy"
    size="mini"
    @change="onChange"
    @input="$emit('input', $event)"
  />
  <!-- TIME FIELDS -->
  <el-time-select
    v-else-if="field.type == 'time' && !field.innerModel"
    v-model="flightOrder[field.modelField]"
    :clearable="false"
    :placeholder="placeholder"
    :picker-options="{
      start: '07:00',
      step: '01:00',
      end: '21:00'
    }"
    :disabled="disabled"
    size="mini"
    @change="onChange"
    @input="$emit('input', $event)"
  />
  <el-time-select
    v-else-if="field.type == 'time' && field.innerModel"
    v-model="flightOrder.orderData[field.modelField]"
    :clearable="false"
    :placeholder="placeholder"
    :picker-options="{
      start: '07:00',
      step: '01:00',
      end: '21:00'
    }"
    :disabled="disabled"
    size="mini"
    @change="onChange"
    @input="$emit('input', $event)"
  />

  <!-- PORT FIELDS -->
  <port-select
    v-else-if="field.type == 'port' && field.innerModel"
    v-model="flightOrder.orderData[field.modelField]"
    :clearable="false"
    :placeholder="placeholder"
    :disabled="disabled"
    :exceptions="exceptions"
    filterable
    can-choose-city
    show-companies
    label-key="code-label"
    size="mini"
    @change="onChange"
    @input="$emit('input', $event)"
  />
  <port-select
    v-else-if="field.type == 'port' && !field.innerModel"
    v-model="flightOrder[field.modelField]"
    :clearable="false"
    :placeholder="placeholder"
    :disabled="disabled"
    :exceptions="exceptions"
    filterable
    can-choose-city
    show-companies
    label-key="code-label"
    size="mini"
    @change="onChange"
    @input="$emit('input', $event)"
  />

  <!-- USER FIELDS -->
  <user-select
    v-else-if="field.type == 'user' && field.innerModel"
    v-model="flightOrder.orderData[field.modelField]"
    :role="field.role"
    :clearable="false"
    :placeholder="placeholder"
    :disabled="disabled"
    filterable
    label-key="code"
    size="mini"
    @change="onChange"
    @input="$emit('input', $event)"
  />
  <user-select
    v-else-if="field.type == 'user' && !field.innerModel"
    v-model="flightOrder[field.modelField]"
    :role="field.role"
    :clearable="false"
    :placeholder="placeholder"
    :disabled="disabled"
    filterable
    label-key="code"
    size="mini"
    @change="onChange"
    @input="$emit('input', $event)"
  />
  <div v-else-if="field.type == 'checkbox' && field.innerModel"
       class="checkbox">
    <el-checkbox
      v-model="flightOrder.orderData[field.modelField]"
      :disabled="disabled"
      size="mini"
      @change="onChange"/>
    <span v-if="link" @click="$emit('open-rules', $event)">{{ dispValue }}</span>
    <span v-else>{{ dispValue }}</span>
  </div>
  <div v-else-if="field.type == 'checkbox' && !field.innerModel"
       class="checkbox">
    <el-checkbox
      v-model="flightOrder[field.modelField]"
      :disabled="disabled"
      size="mini"
      @change="onChange"/>
    <span v-if="link" @click="$emit('open-rules', $event)">{{ dispValue }}</span>
    <span v-else>{{ dispValue }}</span>
  </div>
</template>

<script>
// npm
// models
// rest
// utils
// components
import PortSelect from '@/components/common/PortSelect'
import UserSelect from '@/components/common/UserSelect'

export default {
  name: 'EditOrderField',
  components: {PortSelect, UserSelect},
  props: {
    dispValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    inputIcon: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: null
    },
    listObject: {
      type: Object,
      default () {
        return null
      }
    },
    field: {
      type: Object,
      default () {
        return null
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    exceptions: {
      type: Array,
      default () {
        return null
      }
    },
    flightOrder: Object // eslint-disable-line
  },
  methods: {
    onChange (value, options) {
      if (typeof this.field.callback === 'function') {
        this.field.callback(value, this.field.innerModel ? this.flightOrder.orderData : this.flightOrder, this.field.modelField)
      }
      this.$emit('change', value, options)
    }
  }
}
</script>

<style scoped>
  /* TODO: fix this (not hiding now if in row)  */
  >>> .el-select.el-select--mini .el-input__suffix {
    display: none;
  }
  .checkbox {
    display: flex;
    align-items: center;
    margin-left: 10px;
  }
  .text-field {
    font-size: 12px;
    padding: 0 5px;
  }
  .text-field i {
    line-height: 28px;
  }
  a {
    text-decoration: underline;
    white-space: pre-line;
  }
  .checkbox span {
    line-height: normal;
    padding-left: 10px;
    cursor: pointer;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/views/flight-order/components/EditOrderFieldInput.vue